import {
  AccountDetail,
  AccountDetailSchema,
  ApiRoute,
  ReferralStats,
  ReferralStatsSchema,
  getApiRoute
} from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

export class ReferralApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.REFERRAL),
      requireAuth: true
    });
  }

  async verifyCode(code: string): Promise<AccountDetail> {
    return await this.get(code, AccountDetailSchema, {
      requireAuth: false
    });
  }

  async getStats(): Promise<ReferralStats> {
    return await this.get("me/stats", ReferralStatsSchema, {
      requireAuth: true
    });
  }
}

// Create and export the referral API client instance
export const referralApiClient = new ReferralApiClient();
